/**
 * scroll-reveal.js
 * 
 * 功能：让特定的元素初始隐藏（opacity: 0, translateY(20px)）。
 * 当元素进入可视区域后，执行动画，变为完全可见并回到原位（opacity: 1, translateY(0)）。
 * 当元素离开可视区域时，恢复初始隐藏状态，以便下次进入时再次触发动画。
 * 
 * 使用方法：
 * 在需要动画的 HTML 元素上添加 `class="scroll-reveal"` 即可。
 */

(function() {
  // 1. 动态插入必需的 CSS 样式
  const style = document.createElement('style');
  style.innerHTML = `
    .scroll-reveal {
      opacity: 0;
      transform: translateY(20px);
      /* 设置过渡动画的时长和缓动效果 */
      transition: opacity 0.6s ease-out, transform 0.6s ease-out;
    }
    
    .scroll-reveal.is-visible {
      opacity: 1;
      transform: translateY(0);
    }
  `;
  document.head.appendChild(style);

  // 2. 初始化 Intersection Observer
  const initObserver = () => {
    const observerOptions = {
      root: null, // 使用浏览器视口作为容器
      rootMargin: '0px',
      threshold: 0.1 // 元素有 10% 进入可视区域时就触发
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 当元素进入可视区域时，添加 is-visible 类
          entry.target.classList.add('is-visible');
        } else {
          // 当元素离开可视区域时，移除 is-visible 类，以便下次进入时重新触发动画
          entry.target.classList.remove('is-visible');
        }
      });
    }, observerOptions);

    // 查找所有带有 .scroll-reveal 类的元素并开始观察
    const revealElements = document.querySelectorAll('.scroll-reveal');
    revealElements.forEach(el => observer.observe(el));
  };

  // 确保在 DOM 加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();
